/**
 * @license
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
import { LifecycleManager } from "./lifecycle.js";
import { Reanimator } from "./reanimator.js";
export class RunStateManager {
    #lifecycle;
    #inputs;
    #resumeFrom;
    constructor(resumeFrom, inputs) {
        this.#resumeFrom = resumeFrom;
        this.#lifecycle = new LifecycleManager(resumeFrom?.visits);
        this.#inputs = inputs;
    }
    lifecycle() {
        // TODO: Lifecycle during reanimation should be doing
        // nothing, since we're reconstructing the state of
        // the run from a previously saved state.
        return this.#lifecycle;
    }
    reanimation() {
        return new Reanimator(this.#resumeFrom, this.#inputs);
    }
}
//# sourceMappingURL=manager.js.map